import { FC, InputHTMLAttributes, ReactNode } from "react";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { clsxm } from "@/utils/clsxm";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  label: ReactNode;
  labelClassName?: string;
  children?: ReactNode;
}

const Checkbox = ({
  label,
  labelClassName,
  checked,
  disabled,
  className,
  children,
  ...props
}: IProps) => {
  return (
    <label
      className={clsxm(
        "group flex flex-col cursor-pointer gap-4 border border-new-design-gray-600/[0.08] p-4 text-new-design-gray-500 rounded",
        "hover:border-new-design-purple-300/70 hover:bg-new-design-purple-300/[0.02]",
        checked &&
          "border-new-design-purple-300 bg-new-design-purple-300/[0.04]",
        disabled && "pointer-events-none opacity-70",
        className
      )}
    >
      <span className="flex items-center gap-4">
        <input
          type="checkbox"
          className="hidden appearance-none"
          checked={checked || false}
          disabled={disabled}
          {...props}
        />

        <span className={clsxm(checked && "font-semibold")}>{label}</span>

        <span className="block h-6 min-h-6 w-6 min-w-6 ml-auto">
          {checked ? (
            <MdCheckBox size={24} className="text-new-design-purple-300" />
          ) : (
            <MdCheckBoxOutlineBlank
              size={24}
              className="text-new-design-gray-500/50 group-hover:text-new-design-purple-300/70"
            />
          )}
        </span>
      </span>

      {children}
    </label>
  );
};

export { Checkbox };
